import React from 'react'
import sportIdentifiers from '@/utils/sportIdentifiers/SportIdentifiersConfig'
import LivetickerHeader from '@/components/LivetickerHeader'
import LivetickerTabBar from '@/components/TabBar/LivetickerTabBar'
import LivetickerContentLayout from '@/layouts/Standard/Liveticker/Content'
import ActionButtonsFooter from '@/components/ActionButtonsFooter'
import PageContentLayout from '@/layouts/Standard/PageContentLayout'
import { LivetickerPageProps } from '@/types/page'
import { OddsDisclaimerContextProvider } from '@/utils/oddsDisclaimer/OddsDisclaimerProvider'
import { LivetickerMatchProvider } from '@/utils/liveticker/LivetickerMatchProvider'
import StandardLayout from '@/layouts/Standard'
import AdSlot from '@/components/Ads/AdSlot'
import { removeLastAdsFromLayout } from '@/helpers/adHelper'

type LivetickerLayoutProps = Omit<LivetickerPageProps, 'deeplink'>

const LivetickerLayout = ({
    livetickerMatch,
    layoutData,
    livetickerTabs,
    navigation,
    sportIdentifier,
    outbrainAdComponent,
}: LivetickerLayoutProps) => {
    return (
        <>
            {sportIdentifier === sportIdentifiers.soccer.name ||
            sportIdentifier === sportIdentifiers.wintersport.name ? (
                <LivetickerMatchProvider livetickerMatch={livetickerMatch}>
                    <StandardLayout navigation={navigation} disableBillboard>
                        <OddsDisclaimerContextProvider>
                            <LivetickerHeader sportIdentifier={sportIdentifier} />
                        </OddsDisclaimerContextProvider>
                        {livetickerTabs ? <LivetickerTabBar tabs={livetickerTabs} /> : null}
                        <LivetickerContentLayout layoutData={layoutData} />
                        {navigation?.tag ? <ActionButtonsFooter {...navigation.tag} /> : null}
                        {outbrainAdComponent && <AdSlot {...outbrainAdComponent} />}
                    </StandardLayout>
                </LivetickerMatchProvider>
            ) : (
                <StandardLayout navigation={navigation} disableBillboard>
                    <PageContentLayout
                        layoutData={
                            outbrainAdComponent
                                ? removeLastAdsFromLayout({
                                      layoutData,
                                      extraEndComponent: outbrainAdComponent,
                                  })
                                : layoutData
                        }
                    />
                </StandardLayout>
            )}
        </>
    )
}

export default LivetickerLayout
